<template>
  <div>
    <v-card>
      <v-card-title class='px-2'>
        <Comeback />
        {{ $t('reportPo') }}
        <v-spacer></v-spacer>
        <v-btn
          color='primary'
          :loading='exportLoading'
          class='d-none d-md-block'
          :disabled='exportLoading'
          @click='exportExcel'
        >
          {{ $t('excel') }}
        </v-btn>
        <v-btn
          color='primary'
          class='d-block d-md-none'
          :loading='exportLoading'
          :disabled='exportLoading'
          icon
          fab
          outlined
          @click='exportExcel'
        >
          <v-icon>{{ mdiFileExcelOutline }}</v-icon>
        </v-btn>
      </v-card-title>
      <DateFilters @onSendDate='addPayload' />
      <v-row class='px-2'>
        <v-col cols='12' md='6' lg='3' class='py-0'>
          <v-text-field
            v-model='searchtext'
            dense
            outlined
            :label="`${$t('code')}, ${$t('name')} (${$t('drug_equipment')}) ${$t('pressEnterForSearch')}`"
            @keypress.enter='addPayload(payload.start, payload.end)'
          >
          </v-text-field>
        </v-col>
        <v-col cols='12' md='6' lg='3' class='py-0'>
          <v-select
            v-model='purchase_status_id'
            :items='purchase_status_list'
            :label="$t('status')"
            outlined
            @change='addPayload(payload.start, payload.end)'
            dense
            :no-data-text="$t('no_information')"
            item-text='text'
            item-value='value'
          ></v-select>
        </v-col>
        <v-col cols='12' md='6' lg='3' class='py-0'>
          <v-select
            v-model='poSelected'
            :items='poStatusList'
            :label="$t('type')"
            outlined
            @change='addPayload(payload.start, payload.end)'
            dense
            :no-data-text="$t('no_information')"
            item-text='text'
            item-value='value'
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table
        :headers='columns'
        :items='dataTableList'
        :options.sync='options'
        :loading='loading'
        disable-sort
        hide-default-footer
        :loading-text="$t('data_loading')"
        :no-data-text="$t('no_information')"
      >
        <template #item.purchase_date='{ item }'>
          {{ item.purchase_date | sumdatetime }}
        </template>
        <template #item.purchase_price='{ item }'>
          {{ item.purchase_price | formatPrice }}
        </template>
        <template #item.purchase_date_import='{ item }'>
          <span v-if='item.purchase_status_id==$t(`success`)'>
            {{ item.purchase_date_import | sumdatetime }}
          </span>
          <span v-else> - </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiFileExcelOutline } from '@mdi/js'
import DateFilters from '@/components/basicComponents/DateFilters.vue'
import Comeback from '../Comeback.vue'
import { i18n } from '@/plugins/i18n'
import { reportPo, removeComma } from '../useExcel'
import ConverseDate from '@/components/basicComponents/ConverseDate.vue'
import { sumdate, formatPrice, sumdatetime } from '@/plugins/filters'
import DetailPo from '@/views/po/DetailPo'

export default {
  components: {
    DetailPo,
    DateFilters,
    Comeback,
    ConverseDate,
  },
  filters: {
    formatPrice,
    sumdatetime,
  },
  setup() {
    const XLSX = require('xlsx')
    const payload = ref({})
    const loading = ref(false)
    const dataTableList = ref([])
    const columns = ref([
      {
        text: '#',
        align: 'start',
        sortable: false,
        value: 'number',
        width: 30,
      },
      {
        text: i18n.t('a_number'),
        value: 'purchase_id',
        width: 120,
      },
      {
        text: i18n.t('dealer'),
        value: 'purchase_from_name',
        width: 200,
      },
      {
        text: i18n.t('price'),
        value: 'purchase_price',
        width: 100,
        align: 'right',
      },
      {
        text: i18n.t('dateCreate'),
        value: 'purchase_date',
        width: 160,
      },
      {
        text: i18n.t('dateImport'),
        value: 'purchase_date_import',
        width: 160,
      },
      {
        text: i18n.t('status'),
        value: 'purchase_status_id',
        width: 100,
        align: 'center',
      },
      {
        text: i18n.t('user_is_list'),
        value: 'user_fullname',
        width: 200,
      },
      {
        text: i18n.t('type'),
        value: 'purchase_type_id',
        width: 100,
      },
      {
        text: i18n.t('note'),
        value: 'purchase_comment',
        width: 200,
      },
    ])
    const options = ref({})
    const exportLoading = ref(false)
    const searchtext = ref('')
    const purchase_status_id = ref('')
    const dataDetailPo = ref({})
    const isShowDetailPo = ref(false)
    const purchase_status_list = ref([
      {
        value: '0',
        text: i18n.t('cancel'),
      },
      {
        value: '1',
        text: i18n.t('saveTheDraft'),
      },
      {
        value: '2',
        text: i18n.t('wait_pay'),
      },
      {
        value: '3',
        text: i18n.t('waitWarehouse'),
      },
      {
        value: '4',
        text: i18n.t('success'),
      },

    ])
    const poStatusList = ref([
      {
        text: i18n.t('all'),
        value: '',
      },
      {
        text: 'PO',
        value: '1',
      },
      {
        text: 'PO Online',
        value: '2',
      },
    ])
    const poSelected = ref('')

    const addPayload = (start, end) => {
      payload.value = {
        start,
        end,
        purchase_type_id: poSelected.value,
        searchtext: searchtext.value,
        purchase_status_id: purchase_status_id.value,
        lang: i18n.locale,
      }
      searchReport(payload.value)
    }

    const searchReport = async payload => {
      loading.value = true
      const { data } = await reportPo(payload)
      dataTableList.value = data
      console.log('data : ', data)
      options.value.page = 1
      options.value.itemsPerPage = -1
      loading.value = false
    }

    const exportExcel = async () => {
      exportLoading.value = true
      const { start, end } = payload.value

      let dataExport = await removeComma(
        JSON.parse(JSON.stringify(dataTableList.value)),
      )
      const fileName = `${i18n.t(
        'reportPo',
      )} ${i18n.t('since')} ${sumdate(start)} ${i18n.t(
        'to',
      )} ${sumdate(end)}.xlsx`

      // เมื่อกดปุ่มจะทำการสร้างไฟล์ xcel ด้วย xlsx
      /*  รายงานวิเคราะห์รายการตรวจ */
      const Heading = [
        [
          `${i18n.t('reportPo')} ${i18n.t('since')} ${sumdate(start)} ${i18n.t('to')} ${sumdate(end)} `,
        ],
        [
          '#',
          i18n.t('code'),
          i18n.t('dealer'),
          i18n.t('price'),
          i18n.t('dateCreate'),
          i18n.t('dateImport'),
          i18n.t('status'),
          i18n.t('user_is_list'),
          i18n.t('type'),
          i18n.t('note'),
        ],
      ]
      const ws = XLSX.utils.aoa_to_sheet(Heading)
      XLSX.utils.sheet_add_json(ws, dataExport, {
        header: [
          'number',
          'purchase_id',
          'purchase_from_name',
          'purchase_price',
          'purchase_date',
          'purchase_date_import',
          'purchase_status_id',
          'user_fullname',
          'purchase_type_id',
          'purchase_comment',
        ],
        skipHeader: true,
        origin: -1,
      })
      const wb = XLSX.utils.book_new()
      const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 9 } }]
      const wscols = [
        { wch: 6 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
      ]
      ws['!merges'] = merge
      ws['!cols'] = wscols
      XLSX.utils.book_append_sheet(wb, ws, 'sheet')

      /* พิมร์ files */
      XLSX.writeFile(wb, fileName)
      setTimeout(() => {
        exportLoading.value = false
      }, 1500)
    }

    return {
      poStatusList,
      poSelected,
      dataDetailPo,
      isShowDetailPo,
      purchase_status_list,
      searchtext,
      purchase_status_id,
      loading,
      dataTableList,
      columns,
      options,
      exportLoading,
      payload,
      exportExcel,
      mdiFileExcelOutline,
      addPayload,
    }
  },
}
</script>
